
export default {
  props: {
    feature: Object,
    index: Number,
  },
};
